export function formatPrice(price?: number) {
    const realPrice = price || 0
    return realPrice.toFixed(2).replace(".", ",")
}